import { useEffect } from 'react';
import { generatePath } from 'react-router';

import { integrationsActions } from '@store/integrations/integrations.slice';

import { RouteEnum } from '@enum/route.enum';
import { useCurrentApplicationParams } from '@hook/application/use-current-application-params.hook';
import { useSaveIntegrationMutation } from '@hook/intergration/integration.hooks';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';
import { ConnectorInterface } from '@interface/connector/connector.interface';
import { isExist } from '@util/data/is-exist';

export const useConnectorCard = (connector: ConnectorInterface) => {
  const dispatch = useStoreDispatch();
  const { data: integrations, isLoading: isLoadingIntegrations } = useStoreSelector((state) => state.integrations);
  const [saveIntegration, { isSuccess, isLoading }] = useSaveIntegrationMutation();
  const application = useCurrentApplicationParams();

  const integration = integrations[connector.serviceId];

  const onChange = () =>
    saveIntegration({
      accountId: application.current.account.id,
      serviceId: connector.serviceId,
      application: application.current.id,
      isEnabled: !integration?.isEnabled,
    });

  useEffect(
    () =>
      void (
        isSuccess &&
        isExist(integration) &&
        dispatch(integrationsActions.setStatus({ id: integration.serviceId, isEnabled: !integration.isEnabled }))
      ),
    [isSuccess],
  );

  return {
    integration,
    isLoading: isLoadingIntegrations || isLoading,
    onChange,
    path: generatePath(RouteEnum.IntegrationView.path, { serviceId: connector.serviceId }),
  };
};
